import API from "./api";

const CategorieService = {
  getAll: async () => {
    const response = await API.get("/categories");
    return response.data.donnees;
  },

  getById: async (id: number) => {
    const response = await API.get(`/categories/${id}`);
    return response.data.donnees;
  },

  create: async (payload: any) => {
    const response = await API.post("/categories", payload);
    return response.data.donnees;
  },

  update: async (id: number, payload: any) => {
    const response = await API.put(`/categories/${id}`, payload);
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/categories/${id}`);
    return response.data.donnees;
  },
};

export default CategorieService;
